<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'

    import StatisticsQuotationsService from '../$services/statistics.quotations.service'
    import NumeralMethods from '../$methods/numeral.methods'

    import Search from '../$components/input.search.svelte'
    import Select from '../$components/select.svelte'
    import Table from '../$components/table.svelte'

    export let dateStart = null
    export let dateEnd = null

    // último paso en el que se quedó el usuario
    const STEPS = {
        quoted: { label: 'Cotizó', color: 'is-light' },
        service_selected: { label: 'Eligió servicio', color: 'is-info is-light' },
        pickup_completed: { label: 'Origen completo', color: 'is-info is-light' },
        delivery_completed: { label: 'Destino completo', color: 'is-warning is-light' },
        summary_viewed: { label: 'En el resumen', color: 'is-warning is-light' },
        shipment_created: { label: 'Guía generada', color: 'is-success is-light' },
        shipment_error: { label: 'Error al generar', color: 'is-danger is-light' },
    }

    const stepOptions = Object.entries(STEPS).map(([value, item]) => ({ value, text: item.label }))

    let find = ''
    let steps = ''
    let page = 0
    let metadata = {}
    let quotations = []
    let loading = false
    let seq = 0

    // al cambiar el periodo se vuelve a la primera página
    $: reload(dateStart, dateEnd)

    function reload() {
        page = 0
        load()
    }

    function search() {
        page = 0
        load()
    }

    function filterStep() {
        page = 0
        load()
    }

    async function load() {
        if (!dateStart || !dateEnd) return

        const id = ++seq

        loading = true
        const res = await StatisticsQuotationsService.getHistory({
            dateStart: dateStart.toISOString(),
            dateEnd: dateEnd.toISOString(),
            page,
            find: find || undefined,
            steps: steps || undefined,
        })

        // si cambió el periodo, el paso, la búsqueda o la página mientras cargaba, esta respuesta ya no aplica
        if (id !== seq) return

        loading = false

        if (!res?.success) {
            quotations = []
            return toast({ message: res?.error?.message || 'No se pudo cargar el historial', type: 'is-danger' })
        }

        quotations = res.data.quotations
        metadata = res.data.metadata
    }

    function step(item) {
        return STEPS[item.steps] || { label: item.steps, color: 'is-light' }
    }

    function profit(item) {
        const selected = item.selected
        if (selected?.finalPrice == null || selected?.shipmentCost == null) return null
        return selected.finalPrice - selected.shipmentCost
    }

</script>

<style>
    .user-name {
        font-weight: 600;
        color: #1a1a1a;
    }

    .user-email,
    .muted {
        font-size: 0.8rem;
        color: #9e9e9e;
    }

    .route {
        white-space: nowrap;
    }

    .profit {
        font-weight: 600;
        color: #16a34a;
    }

    .profit.is-negative {
        color: #dc2626;
    }

    .nowrap {
        white-space: nowrap;
    }
</style>

<Table
    items={ quotations.length }
    total={ metadata.total }
    { loading }
    skeletonCols={8}
    bind:metadata
    bind:page
    on:change={ load }
>
    <div slot="header" class="header-filters">
        <div class="header-top">
            <Search bind:value={ find } placeholder="Buscar por nombre o correo del usuario" on:enter={ search } />
        </div>
        <div class="header-actions">
            <Select bind:value={ steps } on:change={ filterStep } text="Último paso" size="small" options={ stepOptions } />
        </div>
    </div>
    <thead slot="thead">
        <tr>
            <th>#</th>
            <th>Usuario</th>
            <th>Último paso</th>
            <th>Fecha</th>
            <th>Ruta</th>
            <th>Servicio</th>
            <th>Precio</th>
            <th>Utilidad</th>
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each quotations as item, index (item._id)}
            <tr>
                <td>{ metadata?.items != null ? (metadata.items * page) + (index + 1) : index + 1 }</td>
                <td>
                    {#if item.user}
                        <div class="user-name">{ item.user.name || item.user.email }</div>
                        {#if item.user.name}
                            <div class="user-email">{ item.user.email }</div>
                        {/if}
                    {:else}
                        <span class="muted">Usuario eliminado</span>
                    {/if}
                </td>
                <td><span class="tag { step(item).color }">{ step(item).label }</span></td>
                <td class="nowrap">{ Moment(item.created).format('YYYY-MM-DD · HH:mm') }</td>
                <td class="route">{ item.pickup || '—' } → { item.delivery || '—' }</td>
                <td>
                    {#if item.selected}
                        <div>{ item.selected.provider } / { item.selected.partner || item.selected.provider }</div>
                        <div class="muted">{ item.selected.service }</div>
                    {:else}
                        <span class="muted">—</span>
                    {/if}
                </td>
                <td class="nowrap">{ item.selected?.finalPrice != null ? NumeralMethods.cash(item.selected.finalPrice) : '—' }</td>
                <td class="nowrap">
                    {#if profit(item) !== null}
                        <span class="profit" class:is-negative={ profit(item) < 0 }>{ NumeralMethods.cash(profit(item)) }</span>
                    {:else}
                        <span class="muted">—</span>
                    {/if}
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
